export default { 
    //英文
    home: {
        subsidiary: 'SUBORDINATE SUBSIDIARY COMPANY',
       
       
    }
  }
  